module.exports = __webpack_public_path__ + "img/list_6_tc.2270b63e.png";